import { useState, useCallback } from "react";
import { ResultsApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";
import { useApiConfig, SERVER_ERROR_MESSAGE } from "common-fe";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useUploadHistory() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const buildConfig = useApiConfig();

  const fetchUploadHistory = useCallback(async (compYearUSEFCompID) => {
    if (!compYearUSEFCompID || !auth.user?.access_token) {
      throw new Error("Missing required parameters");
    }

    setLoading(true);
    setError(null);

    try {
      const api = new ResultsApi(
        new Configuration(buildConfig(MANAGER_API_BASE_URL))
      );

      const response = await api.getUploadHistory(compYearUSEFCompID);

      return response.data || [];
    } catch {
      const errorMessage = SERVER_ERROR_MESSAGE;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [auth.user?.access_token, buildConfig]);

  const getDownloadUrl = useCallback(async (s3Path) => {
    if (!s3Path || !auth.user?.access_token) {
      throw new Error("Missing required parameters");
    }

    try {
      const api = new ResultsApi(
        new Configuration(buildConfig(MANAGER_API_BASE_URL))
      );

      const response = await api.getUploadDownloadUrl(s3Path);
      return response.data?.url;
    } catch {
      const errorMessage = SERVER_ERROR_MESSAGE;
      throw new Error(errorMessage);
    }
  }, [auth.user?.access_token, buildConfig]);

  return { fetchUploadHistory, getDownloadUrl, loading, error };
}
